module.exports = __webpack_public_path__ + "img/am03.91ba8df5.jpg";